import React, { Component } from 'react';
import { Formik } from 'formik';
import { Form, FormGroup, InputGroup, Input, Button } from 'reactstrap';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import PostMan from '../../utils/service';

//import { makeStyles } from '@material-ui/styles';
import './index.css';

// const useStyles = makeStyles(theme => ({
//   close: {
//     padding: theme.spacing(0.5),
//   },
// }));

const ValidationSchema = Yup.object().shape({
  password: Yup.string().required('Please enter a password'),
  confirmPassword: Yup.string()
    .required('Please enter a confirm password')
    .oneOf([Yup.ref('password'), null], 'The passwords you entered did not match.')

});

const FormFeedback = ({ valid, children }) => valid ? null : (
  <div className="formfeedback">
    {children}
  </div>
)

class ResetPassword extends Component {
  constructor() {
    super();
    this.state = {
      message: null,
      initialValues: {
        password: '',
        confirmPassword: '',
      },
      showForm: false
    }

    if (Cookies.get('token') || Cookies.get('accsesToken')) {
      window.location = '/';
    }

  }

  componentDidMount() {
    const hash = this.props.match.params.hash
    PostMan.validatePasswordResetHash({ hash: hash })
      .then(res => {
        this.setState({ showForm: true })
      }).catch(err => {
        window.location = '/';
      })
  }

  onSubmit = (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
    PostMan.saveResetPassword({ ...values, hash: this.props.match.params.hash })
      .then(res => {
        values.password = ''
        values.confirmPassword = ''
        this.setState({ message: "Password has been changed, please login now." })
        setTimeout(() => {
          this.props.history.push(`/login`) 
        }, 2000)
      })
      .catch((error) => {
        this.setState({ message: error.response.data.message })
        // resetForm({})
      })
  }

  mapPropsToValues = (props) => {
    return this.state.initialValues;
  }

  render() {
    const { openToast } = this.state
    // const classes = useStyles();
    const { auth, errors } = this.props
    return (
      <div className="login-wrapper">
        {
          this.state.showForm && <react-fragment>
            <div className="logo-wrapper">
              <img src="/static/img/logo_login.png" alt="logo" width="100%" />
            </div>
            <div className="login-form">
              <h3 className="text-center">Reset Password</h3>
              <Formik
                method="post"
                initialValues={this.state.initialValues}
                validationSchema={ValidationSchema}
                onSubmit={this.onSubmit}
                enableReinitialize={true}
              >
                {({ errors, touched, values, handleChange, handleSubmit, isValid, setTouched }) => (
                  <Form method="post" onSubmit={handleSubmit} noValidate name='subscribeForm' style={{ marginTop: 25 }}>
                    <FormGroup>
                      <InputGroup>
                        <Input type="password"
                          name="password"
                          id="password"
                          placeholder="Password"
                          autoFocus={false}
                          onChange={handleChange}
                          required
                          value={values.password} />
                        <FormFeedback valid={(errors.password) ? false : true}>{errors.password}</FormFeedback>
                      </InputGroup>
                    </FormGroup>
                    <FormGroup>
                      <InputGroup>
                        <Input type="password"
                          name="confirmPassword"
                          id="confirmPassword"
                          placeholder="Confirm Password"
                          autoFocus={false}
                          onChange={handleChange}
                          required
                          value={values.confirmPassword} />
                        <FormFeedback valid={(errors.confirmPassword) ? false : true}>{errors.confirmPassword}</FormFeedback>
                      </InputGroup>
                    </FormGroup>
                    <FormGroup style={{ marginLeft: 10 }}>
                      <Button
                        type="submit" color="success" className="mr-1" style={{ float: "right" }}>Submit</Button>
                    </FormGroup>
                    <div style={{ color: "red" }}>{this.state.message}</div>
                  </Form>
                )}
              </Formik>
            </div>
          </react-fragment>
        }

      </div>
    );
  }
}

export default ResetPassword;




// WEBPACK FOOTER //
// ./client/src/views/Auth/resetPassword.js